// Library Imports
import axios from 'axios';

// Set up axios defaults
/* TODO Using prod link since webpack string replace not working */
axios.defaults.baseURL = 'https://www.firdausi.ca' || 'http://www.firdausi.localhost:8000';
axios.defaults.withCredentials = true;

export async function saveSubscriber (payload) {
   var f = await axios.post('/subscriber/save', payload);
   return f;
}



// WEBPACK FOOTER //
// ./src/backend/index.js